export const routerPaths = {
  root: '/',
  login: '/login',
  callCenter: '/dashboard/call-center',
};
